/**
 * This allows us to disable built in validators for features that we want some
 * other functionality of except for the validation, for example `step="0.1"`
 * for `input[type=number]`.
 *
 * You can disable multiple validators by separating them using commas:
 *   disable-validator="step,min"
 */

angular.module('bribac.validators.disableValidator', [])

  .directive('disableValidator', function() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, element, attr, ctrl) {
        if (!ctrl) return;

        var disabledKeys
        var disabled = []

        function disable(key) {
          var func = ctrl.$validators[key]
          if (func) {
            disabled.push({
              key: key,
              func: func
            })
            delete ctrl.$validators[key]
          }
        }

        function keepIfDisabled(validator) {
          if (disabledKeys.indexOf(validator.key) === -1) {
            ctrl.$validators[validator.key] = validator.func
            return false
          }
          return true
        }

        attr.$observe('disableValidator', function(interpolatedValue) {
          disabledKeys = interpolatedValue.split(',')
          disabled = disabled.filter(keepIfDisabled)
          disabledKeys.forEach(disable)
        });
      }
    }
  })
